import { formatPhone } from 'utils';
import * as Yup from 'yup';
import { validators } from 'ui/configs/formik/validators';

export const signUpCustomerConfig = {
  mapPropsToValues: () => ({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    address: '',
    postalCode: '',
    validDeliveryArea: true,
    latitude: '',
    longitude: '',
    boozer: '',
    intersection: '',
    instructions: '',
    password: '',
    confirmPassword: '',
    terms: false,
  }),
  validationSchema: Yup.object().shape({
    firstName: validators.firstName,
    lastName: validators.lastName,
    phone: validators.phone,
    email: validators.email,
    address: validators.address,
    validDeliveryArea: Yup.bool(),
    postalCode: validators.addressPostalCode,
    boozer: validators.boozer,
    intersection: validators.intersection,
    instructions: validators.instructions,
    password: validators.password,
    confirmPassword: validators.confirmPassword,
    terms: validators.terms,
  }),
  handleSubmit: (
    values,
    { props: { signUpCustomer }, setErrors, setSubmitting },
  ) => {
    signUpCustomer(
      { ...values, phone: formatPhone(values.phone) },
      setErrors,
      setSubmitting,
    );
  },
  displayName: 'SignUpCustomerForm',
};
